import { render, staticRenderFns } from "./Kform.vue?vue&type=template&id=94372b90&scoped=true&"
import script from "./Kform.vue?vue&type=script&lang=js&"
export * from "./Kform.vue?vue&type=script&lang=js&"
import style0 from "./Kform.vue?vue&type=style&index=0&id=94372b90&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94372b90",
  null
  
)

export default component.exports